<template>
  <v-flex class="transferFunds fill-height" data-qa="loanpayment-flex-7sy5z">
    <v-flex v-if="createScreen" xs12 sm12 md12 lg12 xl12 data-qa="loanpayment-flex-njqcqm">
      <v-flex xs12 sm12 md12 lg12 xl12 data-qa="loanpayment-flex-p3o0wu">
        <Loader v-show="loaderEnabled"/>
        <v-flex xs12 sm12 md10 lg10 xl10
          :style="{ background: defaultBackgroundColor }"
         data-qa="loanpayment-flex-39lfj9">
          <v-layout row wrap data-qa="loanpayment-layout-m5w8oa">
            <v-flex xs12 sm12 md10 lg10 xl10 class="pt-4" data-qa="loanpayment-flex-6r29nd">
              <v-card data-qa="loanpayment-card-z6tm0b">
                <v-form ref="form" v-model="isFormValid" data-qa="loanpayment-form-fpbz6">
                  <v-layout row justify-space-between data-qa="loanpayment-layout-lfjlae">
                    <v-flex xs12 sm12 md6 lg6 xl6 class="px-6 pt-6" data-qa="loanpayment-flex-lkhakl">
                      <v-text-field
                        v-model="loanAccountNumber"
                        :color="primaryColor"
                        :label="$t('loanPayment.selectPayeeLabel')"
                        :rules="[rules.requiredRule]"
                        readonly
                        class="transferfunds--nonEditable-textfield"
                       data-qa="loanpayment-text-field-6jzt1d"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 md6 lg6 xl6 class="px-6 pt-4" data-qa="loanpayment-flex-4en4kl">
                      <v-select
                        v-model="selectedAccountNumber"
                        :items="filterDisplay"
                        :label="$t('loanPayment.selectAccountLabel')"
                        :color="primaryColor"
                        item-value="accountId"
                        max-height="auto"
                        background-color="#f0eff7"
                        autocomplete
                        filled
                        required
                        @input="verifyAccount"
                        @change="isPristine"
                        :rules="fieldRules"
                        class="transferFunds--custom-textfield"
                        :hint="selectedAccountHint"
                        persistent-hint
                       data-qa="loanpayment-select-ls3s1o">
                        <template v-slot:selection="data">
                          <v-list-item class="pa-0" data-qa="loanpayment-list-item-xmss7">
                            {{ formatSelectedAccount(data.item) }}
                          </v-list-item>
                        </template>
                        <template v-slot:item="data">
                          <v-list-item-content data-qa="loanpayment-list-item-content-plipe">
                            {{ formatPrimaryLine(data.item) }}
                            <v-list-item-subtitle data-qa="loanpayment-list-item-subtitle-sasf3s"
                              v-text="formatSecondaryLine(data.item)"
                            />
                            <v-divider data-qa="loanpayment-divider-qvpiy"  />
                          </v-list-item-content>
                        </template>
                      </v-select>
                    </v-flex>

                    <v-flex xs12 sm12 md6 lg6 xl6 class="px-6 pt-6" data-qa="loanpayment-flex-vwcavn">
                      <v-text-field
                        v-model="transferAmount"
                        @input="verifyBalance(); restrictDecimal($event);"
                        @change="isPristine"
                        @blur="getAdditionalCharges"
                        :label="$t('loanPayment.amountLabel')"
                        :color="primaryColor"
                        :rules="[rules.requiredAmountRule, rules.numberTypeCheck, rules.isAccBalanceValid, rules.isAmtLessThanOSB]"
                        :prefix="$formatter.currency.getCurrencySymbol(loanPaymentConfig.loanCurrency)"
                        :class="[
                          'transferFunds--custom-textfield',
                          'transferFunds--amountCurrencySymbolDefault',
                          (transferAmount && transferAmount.length)
                            ? false
                            : 'transferFunds--amountCurrencySymbol',
                        ]"
                        filled
                        required
                        @keydown="$formatter.validateAmount($event)"
                        type="number"
                        background-color="#f0eff7"
                       data-qa="loanpayment-text-field-1gyl0o"></v-text-field>
                    </v-flex>

                    <v-flex v-if="loanCharges" xs12 sm12 md6 lg6 xl6 class="px-6 pt-6" data-qa="loanpayment-flex-xso1r">
                      <v-text-field
                        v-model="loanCharges"
                        :color="primaryColor"
                        :label="$t('loanPayment.additionalPaymentCharges')"
                        readonly
                        class="transferfunds--nonEditable-textfield"
                       data-qa="loanpayment-text-field-v3q9hf"></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm12 md6 lg6 xl6 class="px-6 pt-6" data-qa="loanpayment-flex-p2pex">
                      <v-text-field
                        :label="$t('loanPayment.noteLabel')"
                        v-model="transferNote"
                        @change="isPristine"
                        :color="primaryColor"
                        background-color="#f0eff7"
                        class="transferFunds--custom-textfield"
                        :rules="
                          transferNote
                            ? [
                                () =>
                                  (!!transferNote &&
                                    transferNote.length <= 100) ||
                                  $t('loanPayment.noteError'),
                              ]
                            : []
                        "
                        data-qa="loanpayment-text-field-twkyr"
                        filled
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <!-- Product condition alert -->
                  <p class="px-5" data-qa="loanpayment-p-qubtw">
                    <v-alert
                      icon="mdi-information-outline"
                      class="v-alert--info"
                     data-qa="loanpayment-alert-lvq2fm">
                      <span class="body-2 font-weight-bold" data-qa="loanpayment-span-u7o9ai">
                        {{ $t("loanPayment.productInfoAlert.alert") }}
                        <br data-qa="loanpayment-br-f9erf1o"  />
                      </span>

                      <span class="body-2 font-weight-regular" data-qa="loanpayment-span-7djzdb">
                        {{ $t("loanPayment.productInfoAlert.infoLine1") }}
                        <br data-qa="loanpayment-br-durkbc"  />
                        {{ $t("loanPayment.productInfoAlert.infoLine2") }}
                      </span>

                      <br data-qa="loanpayment-br-8cnlz"  />
                      <span
                        class="body-2 font-weight-bold"
                        @click="productDialog = true"
                         data-qa="loanpayment-span-a808vk"><u data-qa="loanpayment-u-z2sqmf">{{
                          $t("loanPayment.productInfoAlert.showMore")
                        }}</u>
                      </span>
                    </v-alert>
                  </p>

                  <v-layout row justify-end data-qa="loanpayment-layout-eb0xxq">
                    <v-flex xs12 sm5 md6 lg6 xl6 class="px-6" data-qa="loanpayment-flex-44plps">
                      <v-btn
                        class="text-capitalize ma-2 white--text py-2 px-4"
                        :color="primaryColor"
                        :disabled="!isProductConditionRead || !isFormValid || isAccountBalance"
                        elevation="2"
                        @click="nextValidate"
                         data-qa="loanpayment-btn-hml9af">{{ $t("loanPayment.nextButton") }}</v-btn
                      >
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-flex>
    </v-flex>
    <!-- Product condition alert dialog -->
    <Modal
      v-if="productDialog"
      :config="modalConfig.loanPayment"
      @btn2Action="productDialog = false; isProductConditionRead = true"
    >
      <span slot="modalContent" class="font-weight-bold" data-qa="loanpayment-span-5dhwi">
        <v-card-text data-qa="loanpayment-card-text-tgkmsn">
          <v-flex v-for="(product, i) in productConditions" :key="i" :data-qa="`loanpayment-flex-f8elfp-${i}`">
            <v-row class="py-2" :data-qa="`loanpayment-row-tuqg4-${i}`">
              <span class="pl-2 font-weight-bold" :data-qa="`loanpayment-span-crg7zf-${i}`">{{
                product.section.title
              }}</span>
              <v-flex
                v-if="
                  product.section.content && !product.section.content.points
                "
                xs10 sm11 md11 lg11 xl11
                class="pl-2"
                :data-qa="`loanpayment-flex-3hcyc5-${i}`">
                {{ product.section.content }}
              </v-flex>
              <v-flex
                v-if="product.section.content.points"
                xs10 sm11 md11 lg11 xl11
                class="pl-2"
                :data-qa="`loanpayment-flex-27wkq8-${i}`">
                <div
                  v-for="(points, idx) in product.section.content.points"
                  :key="idx"
                  :data-qa="`loanpayment-div-lvc8tc-${i}-${idx}`">
                  <ul :data-qa="`loanpayment-ul-wc30ko-${i}-${idx}`">
                    <li :data-qa="`loanpayment-li-ishw4l-${i}-${idx}`">{{ points.point }}</li>
                  </ul>
                </div>
              </v-flex>
            </v-row>
          </v-flex>
        </v-card-text>
      </span>
    </Modal>
    <v-flex v-if="reviewScreen" data-qa="loanpayment-flex-av1ryk">
      <LoanRepaymentSummary @routeToLoanPayment="routeBack()" :config="{ payload }" :display="{ viewOnly }" />
    </v-flex>
  </v-flex>
</template>

<script>
import _ from 'lodash'
import commonService from '@/service/commonService.js'
import preload from '@/util/preload'
import event from '@/util/event'
import loanRepaymentProductConditions from '@/../mocks/loanRepaymentProductConditions.json'
import LoanRepaymentSummary from './LoanRepaymentSummary.vue'
import '@/styles/pages/transferFunds.scss'
import Loader from '../../../../components/common/Loader.vue'
import { formatPrimaryLine, formatSelectedAccount, formatSecondaryLine, formatSelectedHint } from '../../../../util/accountUtil'
import smeRolesMixin from '@/core/mixins/smeRolesMixin.js'

export default {
  name: 'LoanPayment',
  components: {
    Loader,
    LoanRepaymentSummary,
    Modal: () => import('@/components/common/Modal.vue')
  },
  mixins: [ smeRolesMixin ],
  props: {
    loanPaymentConfig: {
      type: Object,
      default: undefined
    }
  },
  data () {
    return {
      createScreen: true,
      reviewScreen: false,
      isFormValid: false,
      isAccountBalance: false,
      loaderEnabled: false,
      noShow: false,
      menu: false,
      search: '',
      listOfAccounts: [],
      payload: {},
      viewOnly: {},
      selectedAccount: undefined,
      loanAccountNumber: '',
      selectedAccountNumber: '',
      transferAmount: [],
      transferNote: '',
      loanCharges: '',
      fromDate: new Date().toISOString().substr(0, 10),
      productDialog: false,
      isProductConditionRead: false,
      productConditions: loanRepaymentProductConditions.conditions,
      noteRules: [
        (v) => !!v || 'Note is required',
        (v) => (v && v.length >= 5) || 'Note must be greater than 5 characters'
      ],
      fieldRules: [(v) => !!v || 'Required Field'],
      rules: {
        requiredRule: (v) => Boolean(v) || 'Required Field',
        requiredAmountRule: (v) => Boolean(v) || this.$t('errors.common.amountRequired'),
        numberTypeCheck: (v) =>
          new RegExp('^\\d+(.\\d\\d?)?$').test(v) ||
          this.$t('errors.common.invalidInput'),
        isAccBalanceValid: (v) => (v && v > 0)
          ? !this.isAccountBalance || this.$t('transferfunds.fundsError')
          : new RegExp('^0*(.0*)$').test(v) ? this.$t('errors.common.minAmountError') : false,
        isAmtLessThanOSB: () => this.transferAmount < this.loanPaymentConfig.outstandingBalance || this.$t('loanPayment.outstandingError')
      },
      modalConfig: {
        loanPayment: {
          enabled: true,
          title: this.$t('loanPayment.productInfoAlert.title'),
          persistent: true,
          btn2Label: this.$t('loanRepaymentSummary.makePaymentBtn'),
          width: 500
        }
      },
      isSmeLogin: JSON.parse(sessionStorage.getItem('isSmeLogin')),
      enableRoleBasedAccess: this.$appSettings.defaultConfigurations.smeRoles.enableRoleBasedAccess
    }
  },
  created () {
    this.getListofAccounts()
    if (this.loanPaymentConfig && this.loanPaymentConfig.accountNumber) {
      this.loanAccountNumber = this.loanPaymentConfig.accountNumber
      this.verifyAccount()
    }
    event.$on('IS_REVIEW_CLEAR', ({ type }) => {
      if (type === 'GoBack') {
        this.reviewScreen = false
        this.createScreen = true
      } else {
        // TODO
        this.reviewScreen = false
        this.createScreen = true
      }
    })
  },
  computed: {
    filteredItems () {
      if (this.listOfAccounts.length) {
        return _.orderBy(
          this.listOfAccounts.filter((item) => {
            if (!this.search) return this.listOfAccounts
            return (
              item.accountName
                .toLowerCase()
                .includes(this.search.toLowerCase()) ||
              item.accountId.toLowerCase().includes(this.search.toLowerCase())
            )
          })
        )
      } else return 0
    },
    filterDisplay () {
      if (this.listOfAccounts.length) {
        const cashISATypes = ['TXSV', 'TXNA', 'TXFR', 'TXEA', 'TXLA']
        const NODRfilterAccounts = this.listOfAccounts.filter((item) => {
          return item.postingsRestriction !== 'DEBIT' && item.currency === this.loanPaymentConfig.loanCurrency && !cashISATypes.includes(item.accountType)
        })
        const validModeOfOperationAccounts = NODRfilterAccounts.filter((item) => {
          return !(item.accountOwnership === 'JOINT' && this.$appSettings.uiFieldsDisplayConfigurations.jointModeOfOperationsForTransfer.exclusionList.includes(item.modeOfOperation.code))
        })
        return validModeOfOperationAccounts
      } else return []
    },
    selectedAccountObj () {
      return this.filterDisplay.find(acc => acc.accountId === this.selectedAccountNumber)
    },
    selectedAccountHint () {
      if (!this.selectedAccountNumber) return ''
      return formatSelectedHint(this.selectedAccountObj)
    }
  },
  methods: {
    isPristine () {
      const formData = {
        selectedAccountNumber: this.selectedAccountNumber,
        transferAmount: this.transferAmount,
        transferNote: this.transferNote
      }
      event.$emit('amendLoanData', formData)
    },
    routeBack () {
      this.reviewScreen = false
      this.createScreen = true
    },
    restrictDecimal (val) {
      if (val && val.length) {
        // Restrict the input to 2 decimal places
        this.transferAmount = val.match(/^\d+\.?\d{0,2}/)
      }
    },
    async getListofAccounts () {
      let accounts = await preload.getAccountsWithBalance(
        JSON.parse(sessionStorage.getItem('username'))
      )
      this.listOfAccounts = await this.getFilteredAccounts(accounts)
    },
    async getAdditionalCharges () {
      if (this.transferAmount && this.transferAmount.length > 0 && this.loanPaymentConfig?.loanStatus !== 'InArrears') {
        const data = {
          adhocRepaymentAmount: {
            amount: this.transferAmount[0],
            currency: this.selectedAccount.currency
          }
        }
        const resp = await commonService.loanAdditionalPaymentCharges(
          this.loanAccountNumber, data
        )

        if (resp && resp.loanAmendCharge && resp.loanAmendCharge.length > 0 && resp.loanAmendCharge[0].eventCode === this.$appSettings.defaultConfigurations.loanScreen.loanAddtionalPayEventCode) {
          const { amount: chargeTaxAmount, currency: chargeTaxCurrency } = resp.loanAmendCharge[0]
          const { amount: chargeAmount, currency: chargeCurrency } = resp.loanAmendCharge[0].chargeAmount
          if (!chargeTaxAmount) {
            this.loanCharges = this.$formatter.currency.format(chargeAmount, chargeCurrency)
          } else this.loanCharges = this.$formatter.currency.format(chargeAmount + chargeTaxAmount, chargeTaxCurrency)
        } else this.loanCharges = ''
      }
    },
    async getAccountBalances (accountNumber) {
      const response = await commonService.getAccountBalances(accountNumber)
      if (response.balances) {
        return response.balances
      }
    },
    verifyAccount () {
      this.listOfAccounts.forEach((acc) => {
        if (acc.accountId === this.selectedAccountNumber) {
          this.selectedAccount = acc
        }
      })
      this.transferAmount = ''
      this.isAccountBalance = false
    },
    verifyBalance () {
      this.transferAmount > 0 &&
      this.transferAmount <=
        (this.selectedAccount ? this.selectedAccount.balance : '')
        ? (this.isAccountBalance = false)
        : (this.isAccountBalance = true)
    },
    nextValidate () {
      this.$refs.form.validate()
      this.createScreen = false
      this.reviewScreen = true
      this.payload = {
        fromAcc: this.selectedAccountNumber,
        toAcc: this.loanAccountNumber,
        transferAmount: this.transferAmount[0],
        startDate: this.fromDate,
        transferNote: this.transferNote || 'Loan Payment',
        charges: this.loanCharges,
        currency: this.loanPaymentConfig.loanCurrency
      }
      this.viewOnly = {
        fromAccType: this.selectedAccount.accountType,
        senderAccName: this.loanAccountNumber
      }
      this.isProductConditionRead = false
      this.productDialog = false
      this.modalConfig.loanPayment.enabled = true
    },
    formatPrimaryLine,
    formatSecondaryLine,
    formatSelectedAccount
  },
  watch: {
    loanPaymentConfig () {
      if (this.loanPaymentConfig && this.loanPaymentConfig.resetData) {
        this.createScreen = true
        this.reviewScreen = false
        this.isAccountBalance = false
        this.transferAmount = []
        this.selectedAccountNumber = ''
        this.transferNote = ''
      }
    }
  }
}
</script>
